<template>
  <div :class="$style.container" v-if="initialLoad">
    <base-icon
      name="logo"
      :class="$style.logo"
      themeColor="light"
      size="50px"
      alt=""
    />
    <infinite-loader />
  </div>
  <div v-else>
    <div :class="$style.header">
      <top-bar :title="title" />
    </div>
    <div :class="$style.body">
      <div
        :class="[$style.sidebar, showMenu ? $style.isVisible : $style.isHidden]"
      >
        <left-menu />
      </div>
      <div :class="$style.main">
        <router-view />
      </div>
    </div>
    <v-dialog />
    <infinite-loader :overlay="true" />
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'

import InfiniteLoader from '@/components/InfiniteLoader'
import LeftMenu from '@/components/LeftMenu'
import TopBar from '@/components/TopBar'
import auth from '@/services/auth'

export default {
  name: 'Main',

  components: { TopBar, LeftMenu, InfiniteLoader },

  data: () => ({ initialLoad: true }),

  computed: {
    ...mapState(['title', 'profile', 'showMenu'])
  },

  created() {
    if (this.profile && this.profile.id) {
      this.initialLoad = false
    } else {
      this.withModalLoading(
        auth
          .getProfile()
          .then(profile => this.setProfile(profile))
          .then(() => (this.initialLoad = false))
          .catch(() => {
            auth.logout()
            this.$router.push({ name: 'login' })
          })
      )
    }
  },

  methods: mapMutations(['setProfile'])
}
</script>

<style lang="scss" module>
.container {
  background-color: $color-primary-dark;
  min-height: 100vh;
  padding: 12vh spacing(1) spacing(2);

  @include wider-than(390px) {
    padding: 27vh spacing(2) spacing(2);
  }
}

.container .logo {
  width: 100px;
  display: block;
  margin: 0 auto;
}

.header {
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 2;

  @media print {
    display: none;
  }
}

.body {
  padding-top: $topbar-height;
  min-height: 100vh;
  display: -webkit-box;
  display: -moz-box;

  @media print {
    padding-top: 0;
  }
}

.sidebar {
  width: $sidebar-width;
  flex-shrink: 0;
  transition: transform 0.3s;
  position: absolute;
  top: $topbar-height;
  bottom: 0;
  z-index: 1;

  &.isHidden {
    transform: translateX(0);
  }

  &.isVisible {
    transform: translateX(-$sidebar-width);
  }

  @include wider-than(1000px) {
    position: relative;
    top: 0;

    &.isVisible {
      transform: translateX(0);
    }
  }

  @media print {
    display: none;
  }
}

.main {
  flex-grow: 1;
  position: relative;
  z-index: 0;
}
</style>
